export const LOGIN_PATH = '/login';
export const OPERATOR_LOGIN_PATH = '/login/operator';
export const CONFIRMATION_EMAIL_PATH = '/email/confirmation/:tokenEmail';
export const PASSWORD_EXPIRED_PATH = '/password/expired';
export const CHANGE_PASSWORD_PATH = '/password/change';
export const RECOVER_PASSWORD_PATH = '/password/recover';
export const RESET_PASSWORD_PATH = '/password/reset/:token';
export const FORBIDDEN_PATH = '/forbidden';
export const SERVICE_UNAVAILABLE_PATH = '/unavailable';
export const CREATION_USERS_PATH = '/users/creation';
export const LIST_USERS_PATH = '/users';
export const DETAIL_USERS_PATH = '/users/detail/:userId';
export const EDIT_USERS_PATH = '/users/edit/:userId';
export const SYSTEM_ACCESS_PATH = '/system-access';
export const IMPERSONATION_HOME_PATH = '/impersonation';
